import './style.scss';

const Loader = () => (
  <div className="cart-loader-container">
    <div className="cart-loader" />
  </div>
);

export { Loader };
